export function ProfileImg({ svgString, className }) {
  return (
    <div
      className={`w-8 h-8 rounded-2xl overflow-hidden flex items-center justify-center ${className}`}
      dangerouslySetInnerHTML={{ __html: svgString }}
    />
  );
}